import PhoneNumberLayout from './PhoneNumberLayout';
import ProjectListLayout from './ProjectListLayout';
import SingleProjectLayout from './SingleProjectLayout';
import { LAYOUT_STATE } from './LayoutTypes';
import { SiteState } from '../SiteState/SiteStateTypes';

function LayoutManagerWrapper({ siteState }: { siteState: SiteState }) {

    return (
        <div style={{ width: "100vw", height: "100vh" }}>
            <LayoutManager siteState={siteState} />
        </div>
    );
}

function LayoutManager({ siteState }: { siteState: SiteState }) {
    const loadedProjects = siteState.staticState.projectInfo;
    const layoutState = siteState.dynamicState.layoutState;

    switch (layoutState) {
        case LAYOUT_STATE.PHONE_NUMBER:
            return <PhoneNumberLayout phoneNumber={siteState.staticState.phoneNumber} projectMap={loadedProjects} phoneNumberState={siteState.dynamicState.layoutBasedState.phoneNumberState} />;
        case LAYOUT_STATE.PROJECT_LIST:
            return <ProjectListLayout projectMap={loadedProjects} projectListState={siteState.dynamicState.layoutBasedState.projectListState} />;
        case LAYOUT_STATE.SINGLE_PROJECT:
            return <SingleProjectLayout projectMap={loadedProjects} singleProjectState={siteState.dynamicState.layoutBasedState.singleProjectState} />;
        default:
            return null;
    }
}

export default LayoutManagerWrapper;
